<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_NODE_SELT') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.nodeId"
              maxlength="100"
              :readonly="true"
              :disabled="true"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="popupCall"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.nodeName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.moduleName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PAGE_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.pageId }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DTSVC_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.dataServiceId }}
            </div>
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-3" />
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_ATRB')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="nodeTypeCode"
              :selected="nodeTypeCode"
              :pageId="pageId"
              codeId="COD_NODE_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRC_TASK_STNRD_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <div class="comm_label">
              {{ processTaskStandardId }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_PRGS_PRC_TASK_STNRD_ID_SET') }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsProcessTaskStandardId'"
        :multiselect="true"
        :hideHeader="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>

    <sui-popup
      v-model="isPopupShow"
      :title="$t('MSG_TIT_NODE_SELT')"
    >
      <p04
        :pageId="pageId"
        @popupClose="popupClose"
        @paramReturn="paramReturn"
      />
    </sui-popup>
  </div>
</template>
<script>
import p04 from './PGE_CMR_00003_P04';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_P03', // eslint-disable-line vue/name-property-casing
  components: {
    p04,
  },
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    setWorkflowNodeInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      inBoundDVOList: [],
      nodeId: '',
      nodeTypeCode: { key: '', label: '' },
      processTaskStandardId: '',
      isPopupShow: false,
      workflowNodeParamList: [],
      frame0: {
        nodeId: '',
        nodeName: '',
        moduleName: '',
        subModuleName: '',
        pageId: '',
        dataServiceId: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PRMT_ID'),
        datafield: 'paramId',
      }, {
        text: this.$t('MSG_TXT_PRMT_NM'),
        datafield: 'paramName',
      }, {
        text: this.$t('MSG_TXT_DVO_SELT'),
        datafield: 'dvoName',
        createwidget: (row, column, value, htmlElement) => {
          const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.inBoundDVOList,
            },
            this.dsProcessTaskStandardId, this.$refs.grid);

          componentInstance.getComponentInstance().$on('select', event => {
            const rowIndex = componentInstance.getDatasetIndex();
            this.dvoSelectChange(rowIndex, event);
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRMT_MAPPING_VAL'),
        datafield: 'paramMappingValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
              checkDisabledFunction: this.checkDisabledFunction,
              maxlength: 100,
            },
            this.dsProcessTaskStandardId, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // frame0: {
    //   deep: true,
    //   handler() {
    //     if (!utils.isEmpty(this.frame0.dataServiceId)) this.setInboundDVOList();
    //     // if (!utils.isUndefined(this.setWorkflowNodeInfo.workflowNodeUid)
    //     //   && !utils.isEmpty(this.setWorkflowNodeInfo.workflowNodeUid)) {
    //     //   this.setInboundDVOList();
    //     // }
    //   },
    // },
  },
  datasets: [{
    id: 'dsProcessTaskStandardId',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'paramId', map: 'paramId' },
      { type: 'string', name: 'paramName', map: 'paramName' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'paramMappingValue', map: 'paramMappingValue' },
      { type: 'string', name: 'workflowNodeParamUid', map: 'workflowNodeParamUid' },
      { type: 'string', name: 'workflowNodeUid', map: 'workflowNodeUid' },
      { type: 'string', name: 'workflowId', map: 'workflowId' },
    ],
  }],
  mounted() {
    // this.ProcessTaskStandardId();
    if (utils.size(this.setWorkflowNodeInfo) > 0) {
      this.setWorkflowNode();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 워크플로우 기본 정보 SET
     */
    setWorkflowNode() {
      if (!utils.isUndefined(this.setWorkflowNodeInfo.workflowNodeParamList)
      && !utils.isEmpty(this.setWorkflowNodeInfo.workflowNodeParamList)) {
        this.workflowNodeParamList = this.setWorkflowNodeInfo.workflowNodeParamList;
      }
      utils.forEach(this.frame0, (value, key) => {
        this.frame0[key] = this.setWorkflowNodeInfo[key];
      });
      this.nodeTypeCode.key = this.setWorkflowNodeInfo.nodeTypeCode;
      this.nodeTypeCode.label = this.setWorkflowNodeInfo.nodeTypeName;

      if (!utils.isEmpty(utils.trim(this.frame0.dataServiceId))) {
        this.setInboundDVOList();
      } else {
        this.processTaskStandardIdReset();
      }
    },
    /**
     * Inbound DVO selectBox 목록 조회
     */
    setInboundDVOList() {
      http.request(this.pageId, 'DTS_CMR_00010', {
        path: {
          'data-service-id': this.frame0.dataServiceId,
        },
      }).then(res => {
        const inBoundDVOList = [];
        this.inBoundDVOList = [];

        utils.forEach(res.data, obj => {
          const option = {
            key: obj.code,
            label: obj.displayName,
          };
          inBoundDVOList.push(option);
        });
        this.inBoundDVOList = inBoundDVOList;

        this.selectProcessTaskStandardId();

      //   if (utils.isUndefined(this.workflowNodeParamList)
      // || utils.isEmpty(this.workflowNodeParamList)) {
      //     this.selectProcessTaskStandardId();
      //   } else {
      //     this.dsProcessTaskStandardId.submit();
      //     this.dsProcessTaskStandardId.setRawData(utils.clone(this.workflowNodeParamList));
      //     this.workflowNodeParamList = [];
      //   }
      });
    },
    /**
     * 업무기준 ID 조회
     */
    selectProcessTaskStandardId() {
      const workflowNodeUid = utils.isUndefined(this.setWorkflowNodeInfo.workflowNodeUid)
      || utils.isEmpty(this.setWorkflowNodeInfo.workflowNodeUid)
        ? ''
        : this.setWorkflowNodeInfo.workflowNodeUid;
      http.request(this.pageId, 'DTS_CMR_00037', {
        query: {
          workflowId: this.workflowId,
          workflowNodeUid,
        },
      }).then(res => {
        const taskIdList = utils.clone(res.data);

        this.processTaskStandardId = utils.join(utils.map(taskIdList, 'paramName'), '|');

        // grid row '편집' 버튼으로 실행 시
        // 최초 1회 기존 파라미터 입력 데이터 존재하면 해당 데이터 grid출력
        // 입력데이터 = this.workflowNodeParamList;
        // 최초 1회만 동작하기 위해 1회 동작 후 입력데이터 리셋.
        if (utils.isUndefined(this.workflowNodeParamList)
         || utils.isEmpty(this.workflowNodeParamList)) {
          this.dsProcessTaskStandardId.submit();
          this.dsProcessTaskStandardId.setRawData(res.data);
        } else {
          this.dsProcessTaskStandardId.submit();
          this.dsProcessTaskStandardId.setRawData(utils.clone(this.workflowNodeParamList));
          this.workflowNodeParamList = [];
        }
      });
    },
    /**
     * 업무기준 ID 리셋
     */
    processTaskStandardIdReset() {
      this.processTaskStandardId = '';
      this.dsProcessTaskStandardId.submit();
      this.dsProcessTaskStandardId.setRawData([]);
    },
    /**
     * 적용
     */
    onClickApply() {
      const workflowNodeInfo = {
        nodeId: this.frame0.nodeId,
        nodeName: this.frame0.nodeName,
        nodeTypeCode: this.nodeTypeCode.key,
        nodeTypeName: this.nodeTypeCode.label,
        dataServiceId: this.frame0.dataServiceId,
        pageId: this.frame0.pageId,
        moduleName: this.frame0.moduleName,
        subModuleName: this.frame0.subModuleName,
        workflowNodeParamList: utils.clone(this.dsProcessTaskStandardId.data),
      };

      if (utils.isEmpty(this.frame0.nodeId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_ID'), this.$t('MSG_TXT_NODE')));
        return false;
      }
      if (!this.validationCheck()) return false;

      this.$emit('paramReturn', workflowNodeInfo, 'workflowNodeInfo');
      this.$emit('popupClose');

      return null;
    },
    onClickClose() {
      this.$emit('popupClose');
    },
    /**
     * 노드 선택 팝업 이벤트
     */
    popupCall() {
      this.isPopupShow = true;
    },
    popupClose() {
      this.isPopupShow = false;
    },
    paramReturn(data) {
      utils.forEach(this.frame0, (value, key) => {
        this.frame0[key] = data[0][key];
      });
      if (!utils.isEmpty(utils.trim(this.frame0.dataServiceId))) {
        this.setInboundDVOList();
      } else {
        this.processTaskStandardIdReset();
      }
    },
    /**
     * Inbound DVO Event
     * Inbound DVO 값에 따라 파라미터매핑값 입력 제한.
     */
    dvoSelectChange(rowIndex, event) {
      if (utils.startsWith(event, 'entity')) {
        this.dsProcessTaskStandardId.setData(rowIndex, 'paramMappingValue', event);
      } else if (utils.startsWith(event, 'ResponseSize')) {
        this.dsProcessTaskStandardId.setData(rowIndex, 'paramMappingValue', 'size');
      } else {
        this.dsProcessTaskStandardId.setData(rowIndex, 'paramMappingValue', '');
      }
    },
    paramMappingValueDisabled(rowIndex) {
      const { dvoName } = this.dsProcessTaskStandardId.data[rowIndex];
      if (utils.isEmpty(dvoName)) return false;
      if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
    /**
     * 입력 체크
     */
    validationCheck() {
      let flag = true;

      utils.forEach(this.dsProcessTaskStandardId.data, (obj, row) => {
        if (utils.isEmpty(obj.dvoName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_DVO_SELT')),
          null,
          () => {
            this.gridSetFocus(row, 'dvoName');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.paramMappingValue)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRMT_MAPPING_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'paramMappingValue');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    /**
     * grid disabled Function
     */
    checkDisabledFunction(rowData) {
      const { dvoName } = rowData;

      if (utils.isEmpty(dvoName)) {
        return false;
      } if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
